export enum MergeState {
    Original = 1,
    Merged,
    MergeResult
}